export const sortByDate = (filteredHistory:HistoryLogEntryResponse[]):
 HistoryLogEntryResponse[] => {
  return filteredHistory.sort(
    (a: HistoryLogEntryResponse, b:HistoryLogEntryResponse) => {
      if (a.createdAt > b.createdAt) return -1;
      if (a.createdAt < b.createdAt) return 1;

      return 0;
    });
};
